/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {NineToFive} from "../NineToFive";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SymbolUtils} from "../utils/SymbolUtils";
import {NineToFiveSymbol, NineToFiveSymbolStates} from "../reels/symbols/NineToFiveSymbol";
import {WinConfigUtilBased} from "../utils/WinConfigUtil";
import {NineToFiveModel} from "../server/NineToFiveModel";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";

export class NineToFiveIdleNormalPresentation implements FlowStatePresentation {
    private _tl:gsap.core.Timeline;
    constructor() {
        this._tl = gsap.timeline();
        NineToFive.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => this.skip(data));
    }

    public start(flowStateController:FlowStateController) {
        this._tl = gsap.timeline();
        NineToFive.model.hasWonFsClient = false;

        this._tl.add(() => {});
        this._tl.add(() => {}, '>0.2');
        this.setupWinToggle();
        this._tl.repeat(-1);

        flowStateController.setSkipCallback(()=>this.onComplete(flowStateController));

    }

    private onComplete(flowStateController: FlowStateController): void {
        const wasBonus: boolean = NineToFive.model.gameData?.mode.indexOf("FREESPIN") > -1 && NineToFive.model.gameData?.nextMode === GameMode.NORMAL;
        flowStateController.finish();
    }

    private skip(data: APIFeatureBetEventData) {
        this._tl.kill();
        NineToFive.baseGameReelView.getAllSymbols().forEach((sym) => sym.resetState());
        NineToFive.winView.clear();
        NineToFive.foregroundElements.killGameIntro();
        NineToFive.soundPlayer.stopSound("gameStartOneShot");
        //this.onComplete(flowStateController)
    }

    private setupWinCapWinToggle(): void {
        const tl = gsap.timeline();
        tl.add(NineToFive.winView.showAfterMaxWin(NineToFive.model.winData.accumulatedWin));
        this._tl.add(tl);
    }

    private setupWinToggle(): void {
        if (NineToFive.model.data.brokeTheBank) {
            this.setupWinCapWinToggle();
            return;
        }

        if (NineToFive.model.winData == undefined ||
            NineToFive.model.winData.lines.length == 0) {
            return;
        }

        const wins = NineToFive.model.winData.lines;

        if (wins.length > 1) {
            wins.slice().sort((a,b) => b.betWayWin.multipliedAmount - a.betWayWin.multipliedAmount).forEach((win) => {
                const winSymbols:NineToFiveSymbol[] = [];
                let noWinSymbols:NineToFiveSymbol[] = [];
                NineToFive.baseGameReelView.getAllSymbols().forEach((sym) => {
                    if (win.coordinates.some((coord) => sym.reelID == coord.column && sym.reelPosition == coord.row)) {
                        winSymbols.push(sym);
                    } else {
                        noWinSymbols.push(sym);
                    }
                });
                noWinSymbols =
                    noWinSymbols.concat(NineToFive.baseGameReelView.getAllSymbolsActually()
                        .filter((sym) => sym.reelPosition == -1 ||
                            sym.reelPosition == 4));

                const tl = gsap.timeline();
                tl.add(noWinSymbols.map((sym) => sym.setNoWin()), 0);

                const winSymbolsTl = gsap.timeline();
                winSymbols.reverse().forEach((sym) => winSymbolsTl.add(sym.getWinAnimationBased(), '<'));
                tl.add(winSymbolsTl);

                //tl.add(NineToFive.winView.countUpWin(win.betWayWin.multipliedAmount, 0, 1, win.betWayWin.numberOfCombinations), '<');
                if (!NineToFive.isWinBelowStake()) {
                    tl.add(NineToFive.winView.winToggle(win.betWayWin.multipliedAmount, win.betWayWin.numberOfCombinations), '<');
                }
                tl.add(noWinSymbols.map((sym) => sym.setNormal()));
                tl.add(() => {}, '>0.3');
                this._tl.add(tl);
            })
        }

        const winSymbols = SymbolUtils.getAllSymbolsWithStateByReel(NineToFiveSymbolStates.WIN_TINY);
        const noWinSymbols =
            SymbolUtils.getAllSymbolsWithState(NineToFiveSymbolStates.NO_WIN)
            .concat((NineToFive.baseGameReelView.getAllSymbolsActually()
                                                .filter((sym) => sym.reelPosition == -1 ||
                                                                 sym.reelPosition == 4)));

        const tl = gsap.timeline();
        tl.add(noWinSymbols.map((sym) => sym.setNoWin()), 0);

        const winSymbolsTl = gsap.timeline();
        winSymbols.reverse().forEach((reel) => reel.forEach((sym) => winSymbolsTl.add(sym.getWinAnimationBased(), '<')));
        tl.add(winSymbolsTl);

        //tl.add(NineToFive.winView.countUpWin(win.betWayWin.multipliedAmount, 0, 1, win.betWayWin.numberOfCombinations), '<');
        if (!NineToFive.isWinBelowStake()) {
            tl.add(NineToFive.winView.winToggle(NineToFive.model.winData.accumulatedWin, NineToFive.model.winData.winWays), '<');
        }
        tl.add(noWinSymbols.map((sym) => sym.setNormal()));
        tl.add(() => {}, '>0.7');
        this._tl.add(tl);
    }
}